<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <!-- <div v-if="$gate.isSysAdmin()"> -->
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>{{ $route.meta.title }}</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
      <div class="col-lg-12">
			<div class="card card-danger card-outline collapsed-card">
		<div class="card-header">
			<div class="card-title">Data Filters</div>
			<div class="card-tools">
      <!-- Collapse Button -->
      <button type="button" class="btn btn-tool btn-danger" data-card-widget="collapse"><i class="fas fa-minus"></i> Show/Hide</button>
    </div>
		</div>
		<div class="card-body">
			<div class="col-lg-12 float-left">
				<div class="row">

					<!-- <div class="col-sm-4" v-if='$gate.isZonalManager()'> -->

					<div class="col-sm-4">
						<div class="form-group">
							<span class="right badge badge-secondary">Created From:</span>
								<input type="date" class="form-control" v-model="params.from_date" placeholder="From date">
							</div>
					</div>
					<div class="col-sm-4">
						<div class="form-group">
							<span class="right badge badge-secondary">Created Till:</span>
								<input type="date" class="form-control" v-model="params.to_date" placeholder="To date">
							</div>
					</div>
					<div class="col-sm-4" style="display: none;">
						<div class="form-group">
							<span class="right badge badge-secondary">Confirmed Delivery Date:</span>
								<input type="date" class="form-control" v-model="params.confirmed_delivery_date" placeholder="Confirmed Delivery date">
							</div>
					</div>
					<div class="col-sm-4">
						<div class="form-group">
							<span class="right badge badge-secondary">Preferred Delivery Date:</span>
								<input type="date" class="form-control" v-model="params.preferred_delivery_date" placeholder="Preferred Delivery date">
							</div>
					</div>
					<div class="col-sm-4">
						<div class="form-group">
							<span class="right badge badge-secondary">Pick Status:</span>
							<select v-model="params.delivery_status" style="width: 100% !important" class="form-control">
                            <option v-for="j in delivery_status_list" :key="j.id" :value="j.status">
                              {{ j.status}}
                             </option>
                             <!-- <span v-if="errors.delivery_route" :class="['badge bg-danger']">Please choose a route from route master</span> -->
                          </select>
        				</div>
					</div>
                    <div class="col-sm-4" v-if='$gate.isWarehouseManager()==true || $gate.isServiceAdmin()==true || $gate.isHRAdmin()==true ||  $gate.isOnlineSalesManager()==true || $gate.isOnlineSalesAssociate()==true || $gate.isCCManager()==true || $gate.isCCAgent()==true  || $gate.isServiceManager()==true || $gate.isZonalManager()==true || $gate.isMISAdmin()==true || $gate.isSecondaryMISAdmin()==true || $gate.isPurchaseAdmin()==true || $gate.isPurchaseManager()==true || $gate.isSecondaryPurchaseAdmin()==true || $gate.isSecondaryPurchaseManager()==true'>
                        <div class="form-group">
                            <span class="right badge badge-secondary">Selling Branch:</span>
                            <select class="form-control" v-model="params.branch" @change="getLinkedBranches">
                                <option v-for="branch in branches" :value="branch.branch_code">{{branch.branch}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="col-sm-4">
<!--                        <div class="col-sm-4" v-if='$gate.isWarehouseManager()==true || $gate.isServiceAdmin()==true  || $gate.isServiceManager()==true || $gate.isZonalManager()==true || $gate.isMISAdmin()==true || $gate.isSecondaryMISAdmin()==true'>-->
                        <div class="form-group">
                            <span class="right badge badge-secondary">Stock Origin:</span>
                            <select class="form-control" v-model="params.serving_branch">
                                <option v-for="branch in linked_branches" :value="branch.inventory_source">{{branch.inventory_source}}</option>
                            </select>
                        </div>
                    </div>

					<div class="col-sm-4">
						<div class="form-group">
							<span class="right badge badge-secondary">Delivery Route:</span>
							<select v-model="params.delivery_route" style="width: 100% !important" class="form-control">
                            <option v-for="j in delivery_routes" :key="j.id" :value="j.id">
                              {{ j.branch }}, {{ j.route }}
                             </option>
                             <!-- <span v-if="errors.delivery_route" :class="['badge bg-danger']">Please choose a route from route master</span> -->
                          </select>
						</div>
					</div>
					<div class="col-sm-4">
						<div class="form-group">
							<span class="right badge badge-secondary">Item Category:</span>
                          <select v-model="params.delivery_item_category" style="width: 100% !important" class="form-control">
                            <option v-for="j in delivery_item_categories" :key="j.id" :value="j.id">
                              {{ j.category }}
                             </option>
                             <!-- <span v-if="errors.delivery_route" :class="['badge bg-danger']">Please choose a route from route master</span> -->
                          </select>
						</div>
					</div>
					<div class="col-sm-4">
						<div class="form-group">
							<span class="right badge badge-secondary">Combo:</span>
                          <select v-model="params.is_combo" style="width: 100% !important" class="form-control">
                            <option value="0">
                              No
                             </option>
							 <option value="1">
                              Yes
                             </option>
                             <!-- <span v-if="errors.delivery_route" :class="['badge bg-danger']">Please choose a route from route master</span> -->
                          </select>
						</div>
					</div>
					<div class="col-sm-4">
						<div class="form-group">
							<span class="right badge badge-secondary">DC Done:</span>
                          <select v-model="params.is_billed" style="width: 100% !important" class="form-control">
                            <option value="0">
                              No
                             </option>
							 <option value="1">
                              Yes
                             </option>
                             <!-- <span v-if="errors.delivery_route" :class="['badge bg-danger']">Please choose a route from route master</span> -->
                          </select>
						</div>
					</div>
					<div class="col-sm-4">
						<div class="form-group">
							<span class="right badge badge-secondary">Invoice Done:</span>
                          <select v-model="params.is_invoiced" style="width: 100% !important" class="form-control">
                            <option value="0">
                              No
                             </option>
							 <option value="1">
                              Yes
                             </option>
                             <!-- <span v-if="errors.delivery_route" :class="['badge bg-danger']">Please choose a route from route master</span> -->
                          </select>
						</div>
					</div>
					<div class="col-sm-4">
						<div class="form-group">
							<span class="right badge badge-secondary">Summary:</span>
                          <select v-model="params.summary" style="width: 100% !important" class="form-control">
							 <option value="0">
                              Pending
                             </option>
							 <option value="2">
                              Cancelled
                             </option>
							 <option value="1">
                              Completed
                             </option>
                             <!-- <span v-if="errors.delivery_route" :class="['badge bg-danger']">Please choose a route from route master</span> -->
                          </select>
						</div>
					</div>
					<div class="col-sm-4">
						<div class="form-group">
							<span class="right badge badge-secondary">Urgent:</span>
                          <select v-model="params.is_urgent" style="width: 100% !important" class="form-control">
                            <option value="0">
                              No
                             </option>
							 <option value="1">
                              Yes
                             </option>
                             <!-- <span v-if="errors.delivery_route" :class="['badge bg-danger']">Please choose a route from route master</span> -->
                          </select>
						</div>
					</div>
					<div class="col-sm-4">
						<div class="form-group">
							<span class="right badge badge-secondary">GST BILL REQUIRED:</span>
                          <select v-model="params.gst_bill_required" style="width: 100% !important" class="form-control">
                            <option value="0">
                              No
                             </option>
							 <option value="1">
                              Yes
                             </option>
                             <!-- <span v-if="errors.delivery_route" :class="['badge bg-danger']">Please choose a route from route master</span> -->
                          </select>
						</div>
					</div>
					<div class="col-sm-4">
						<div class="form-group">
							<span class="right badge badge-secondary">Gatepass No:</span>
								<input class="form-control" placeholder="Enter gatepass" v-model="params.gatepass_no" type="text">
							</div>
					</div>
					<div class="col-sm-4">
						<div class="form-group">
							<span class="right badge badge-secondary">Customer Name:</span>
								<input class="form-control" placeholder="Enter customer name" v-model="params.customer_name" type="text">
							</div>
					</div>
					<div class="col-sm-4">
						<div class="form-group">
							<span class="right badge badge-secondary">Phone Number:</span>
								<input class="form-control" placeholder="Enter phone number" v-model="params.phone_number" type="number" min="1">
							</div>
					</div>
					<div class="col-sm-4">
						<div class="form-group">
							<span class="right badge badge-secondary">Item Code:</span>
								<input class="form-control" placeholder="Enter itemcode" v-model="params.item_code" type="text" min="1">
							</div>
					</div>
					<div class="col-sm-4">
						<span class="right badge badge-secondary">POS ID:</span>
						<div class="form-group"><input class="form-control" placeholder="Enter delivery commitment id" v-model="params.dc_id" type="number" min="1">
								</div>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-4">
						<div class="form-group">
								<button class="btn btn-primary" style="width:100% !important;"  @click="getAllDeliveryCommitments()">Search</button>
							</div>
					</div>
					<div class="col-sm-4" v-if="!$gate.isCCAgent()">
						<div class="form-group">
								<button class="btn btn-success" style="width:100% !important;" @click="exportCommitments">Export</button>
							</div>
					</div>
					<div class="col-sm-4">
						<div class="form-group">
								<button class="btn btn-danger" style="width:100% !important;" @click="reset">Reset</button>
							</div>
					</div>
				</div>
			</div>
		</div>
			</div>
		</div>
			<br>
			<div class="col-lg-12">
					<div class="row">
						<div class="col-md-9">
							DATASHEET V1.4 &nbsp;<button class="btn btn-secondary" @click="getAllDeliveryCommitments()"><i class="fa fa-refresh"></i> Refresh</button>
                            <br>
                            <br>
                            <div class="col-md-12">
                                <div class="row" align="center">

                                    <div class="col-lg-3 col-12">
                                        <!-- small box -->
                                        <div class="small-box bg-danger">
                                            <div class="inner">
                                                <h4>{{total_results}}</h4>
                                                <p>Total Entries</p>
                                            </div>
                                            <div class="icon">
                                                <i class="ion ion-person-add"></i>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-3 col-12" v-if="$gate.isMISAdmin() || $gate.isSecondaryMISAdmin()">
                                        <!-- small box -->
                                        <div class="small-box bg-danger">
                                            <div class="inner">
                                                <h4>{{dc_total | dotNumbers}}</h4>
                                                <p>Total Value</p>
                                            </div>
                                            <div class="icon">
                                                <i class="ion ion-pie-graph"></i>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-3 col-12" v-if="$gate.isMISAdmin() || $gate.isSecondaryMISAdmin() || $gate.isWarehouseManager() || $gate.isStoreManager()">
                                        <!-- small box -->
                                        <div class="small-box bg-orange">
                                            <div class="inner">
                                                <h4>{{dc_pending | dotNumbers}}</h4>
                                                <p>Pending Amount</p>
                                            </div>
                                            <div class="icon">
                                                <i class="ion ion-bag"></i>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-3 col-12" v-if="$gate.isMISAdmin() || $gate.isSecondaryMISAdmin() || $gate.isWarehouseManager() || $gate.isStoreManager()">
                                        <!-- small box -->
                                        <div class="small-box bg-success">
                                            <div class="inner">
                                                <h4>{{dc_collected | dotNumbers}}</h4>
                                                <p>Collected Amount</p>
                                            </div>
                                            <div class="icon">
                                                <i class="ion ion-bag"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
						</div>
						<div class="col-md-3">
							<pagination :pagination="pagination"
						 	@prev="getAllDeliveryCommitments(pagination.prevPageUrl)"
						  @next="getAllDeliveryCommitments(pagination.nextPageUrl)"
						></pagination>
						</div>
					</div>
					<br>
                <div class="card overflow-x" :class="(i.delivery_status == 'New')?'badge-secondary':'badge-none'" :style="((i.preferred_delivery_date == today_date || i.confirmed_delivery_date == today_date)&&(i.delivery_status != 'New'))?'background-color:peachpuff; border-color:peachpuff; border:none !important; border-radius 30px !important; margin-bottom: 10px !important;':'border:none !important; border-radius 30px !important; margin-bottom: 10px !important; border:none !important;'" v-for="i in delivery_commitments">
                    <div class="card-body overflow-x">
                            <div class="col md-12">
                                <div class="row" >
                                    <div class="col-md-12" style="padding: 3% !important;">
                                        <div class="row">
                                            <div class="col-md-6 left" style="">
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <span class="left badge badge-info">POS ID:  {{i.id}}</span><br>
                                                        <span class="left badge badge-secondary">Gatepass No:</span>
                                                        <h1>{{i.gatepass_no}}</h1>
                                                        <span class="left badge badge-secondary">Order Date:</span>
                                                        <p>{{i.created_at | addedDate}}</p>
                                                        <span class="left badge badge-secondary">Customer:</span>
                                                        <p>{{i.customer_name}}</p>
                                                        <span class="left badge badge-secondary">Phone No:</span>
                                                        <p>{{i.phone_number}} | {{i.alt_phone_number}}</p>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <span class="left badge badge-secondary">Item Codes:</span>
                                                        <p>{{i.item_code_1}} - {{i.brand_1}}  - {{i.model_1}}  |  {{i.item_code_2}} - {{i.brand_2}}  - {{i.model_2}}  |  {{i.item_code_3}} - {{i.brand_3}}  - {{i.model_3}}  |  {{i.item_code_4}} - {{i.brand_4}}  - {{i.model_4}}</p>
                                                        <span class="left badge badge-danger">Item Category:</span>
                                                        <h3>{{i.master_delivery_item_category.category}}</h3>
                                                        <span class="left badge badge-danger">Preferred Delivery Date:</span>
                                                        <h4>{{i.preferred_delivery_date  | formattedDateWithOne}}</h4>
                                                        <br>
                                                        <div class="row">
                                                            <span class="left badge badge-danger">CONFIRMED DELIVERY DATE:</span>
                                                            <h4 v-if="i.confirmed_delivery_date != null">{{i.confirmed_delivery_date | formattedDateWithOne}}</h4>
                                                            <p><button class="btn btn-success" @click="updateConfirmedDeliveryDateModalPrompt(i)" v-if="i.confirmed_delivery_date == null"> Update Confirmed Date</button>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6 right" style="">


                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <h4>{{i.company_id}} | {{i.branch_code}}</h4>
                                                        <span class="left badge badge-primary">Shipping From:</span>
                                                        <h5>{{i.linked_warehouse}}</h5>

                                                        <span class="left badge badge-primary">Delivery Status:</span>
                                                        <h5>{{i.delivery_status}}</h5>
                                                        <span class="left badge badge-primary">Installation Required:</span>
                                                        <h5 v-if="i.installation_required == true">YES</h5>
                                                        <h5 v-if="i.installation_required != true">NO</h5>
                                                        <br>
                                                        <div class="row">
                                                            <button class="btn btn-warning" @click="gatepassImageModalPrompt(i)"> <i class="fa fa-eye"></i> Gatepass</button>
                                                            &nbsp;
                                                            <button v-if="i.receipt_no != null" class="btn btn-warning" @click="receiptImageModalPrompt(i)"> <i class="fa fa-eye"></i> DO/Receipt</button>
                                                        </div>
                                                        <br>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <span v-if="i.is_combo_order == true" class="left badge badge-success"><h4>COMBO</h4></span>
                                                        <span v-if="i.is_urgent == true" class="left badge badge-danger"><h4>URGENT</h4></span>
                                                        <span v-if="i.gst_bill_required == true" class="left badge badge-danger"><h4>GST BILL</h4></span>
                                                        <br>
                                                        <span class="left badge badge-secondary">Route:</span>
                                                        <p>{{i.master_delivery_route.route}}</p>
                                                        <span class="left badge badge-secondary">Pincode:</span>
                                                        <p>{{i.pincode}}</p>
                                                        <span class="left badge badge-secondary">Landmark:</span>
                                                        <p>{{i.landmark}}</p>
                                                        <br>
                                                        <div class="row">
                                                            <button style="width: 100% !important;" class="btn btn-danger" @click="viewDeliveryCommitment(i)"><i class="fa fa-list"></i> View More</button>
                                                        </div>
                                                        <br>
                                                        <div class="row">
                                                            <button style="width: 100% !important;" class="btn btn-danger" @click="updateStatusModalPrompt(i)"> <i class="fa fa-cog"></i> Change Status</button>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                        <div class="row overflow-x overflow-y"  style="display:none;">
                                            <table class="table table-striped table-bordered table-hover overflow-y">
                                                <thead>
                                                <tr>


                                                    <th scope="col" style="width:10%">Gatepass</th>
                                                    <th scope="col" style="width:15%">Buyback Status</th>
                                                    <th scope="col" style="width:20%">Payment Status</th>
                                                    <th scope="col" style="width:15%">DC No.</th>
                                                    <th scope="col" style="width:25%">Invoice & Ewaybill</th>
                                                    <th scope="col" style="width:15%">Manage</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr>
                                                    <td>
                                                        <button class="btn btn-primary" @click="gatepassImageModalPrompt(i)">View Gatepass</button>
                                                        <p v-if="i.receipt_no != null">DO Details:</p>
                                                        <p v-if="i.receipt_no != null">{{i.receipt_no}}</p>
                                                        <button v-if="i.receipt_no != null" class="btn btn-primary" @click="receiptImageModalPrompt(i)">View DO</button>
                                                    </td>
                                                    <td>
                                                        <p v-if="i.buyback_collected != true"><b>PENDING</b></p>
                                                        <p v-if="i.buyback_collected == true"><b>COMPLETED</b></p>
                                                        <button class="btn btn-primary" v-if="i.buyback_collected != true" @click="updateBuybackStatusModalPrompt(i)">Update Buyback</button>
                                                    </td>
                                                    <td>
                                                        <p v-if="i.pending_amount != i.collected_amount">Payment Status:<b>PENDING</b></p>
                                                        <p v-if="i.pending_amount == i.collected_amount">Payment Status:<b>COMPLETED</b></p>
                                                        <p v-if="i.total_amount != null">Total Amount: <b>{{i.total_amount}}</b></p>
                                                        <p v-if="i.pending_amount != null">Pending: <b>{{i.pending_amount}}</b></p>
                                                        <p v-if="i.collected_amount != null">Collected: <b>{{i.collected_amount}}</b></p>
                                                        <button class="btn btn-primary" @click="updateCollectedAmountModalPrompt(i)">Update Collected Amount</button>
                                                    </td>
                                                    <td>
                                                        <button class="btn btn-primary" @click="updateDCModalPrompt(i)" v-if="i.sale_order_no == null">Update DC</button>
                                                        <p v-if="i.sale_order_no != null"><b>{{i.sale_order_no}}</b></p>
                                                    </td>
                                                    <td>
                                                        <button class="btn btn-primary" @click="updateInvoiceModalPrompt(i)" v-if="i.invoice_no == null">Update Invoice</button>
                                                        <button class="btn btn-primary" @click="updateEwaybillModalPrompt(i)" v-if="i.ewaybill_generated == 0">Update E-waybill</button>
                                                        <p v-if="i.invoice_no != null">Invoice No: <b>{{i.invoice_no}}</b></p>
                                                        <p v-if="i.ewaybill_no != null">Ewaybill No: <b>{{i.ewaybill_no}}</b></p>
                                                    </td>
                                                    <td>
                                                        <div class="col-md-12">
                                                            <div class="row" v-if="$gate.isBranchManager()">
                                                                <button v-if="i.manager_approved ==0" style="width: 100% !important;" class="btn btn-danger" @click="approveDCModalPrompt(i)">Approve DC</button>
                                                                <p v-if="i.manager_approved ==1"><span class="left badge badge-success">MANAGER APPROVED</span></p>
                                                            </div>
                                                            <br>
                                                            <div class="row">
                                                                <button style="width: 100% !important;" class="btn btn-danger" @click="viewDeliveryCommitment(i)">View More</button>
                                                            </div>
                                                            <br>
                                                            <div class="row">
                                                                <button style="width: 100% !important;" class="btn btn-danger" @click="updateStatusModalPrompt(i)">Change Status</button>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>

                                                <!-- <tr v-for="i in master_delivery_routes">
                                                    <td>{{i.branch}}</td>
                                                    <td>{{i.route}}</td>
                                  <td>{{i.description}}</td>
                                  <td>{{i.validity}}</td>
                                  <td>
                                                                <button class="btn btn-success fa fa-play" v-if="i.validity == 'Inactive'" @click="changeStatus(i.id)"></button>
                                                                <button class="btn btn-danger fa fa-square" v-else-if="i.validity == 'Active'" @click="changeStatus(i.id)"></button>
                                                    </td>
                                                </tr> -->
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
					</div>




					<div class="card-footer">
						<pagination :pagination="pagination"
						 	@prev="getAllDeliveryCommitments(pagination.prevPageUrl)"
						  @next="getAllDeliveryCommitments(pagination.nextPageUrl)"
						></pagination>
					</div>
				<!-- </div> -->
			</div>
			<div class="modal" tabindex="-1" role="dialog" id="receiptImageModal">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Receipt Image</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <img :src="receipt_image" width="700" height="700" @click="viewImage()">
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
<div class="modal" tabindex="-1" role="dialog" id="gatepassImageModal">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Gatepass Image</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <img :src="gatepass_image" width="700" height="700" @click="viewImage()">
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
<div class="modal" tabindex="-1" role="dialog" id="updateDCModal">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Update DC Details</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group">
			<span class="right badge badge-secondary">Sales DC No: </span>
        	<input type="text" v-model="sale_order_no" placholder="Enter the sale order number" class="form-control">
        </div>
		<div class="form-group">
			<span class="right badge badge-secondary">Sales DC Date: </span>
        	<input type="date" v-model="sale_order_date" placholder="Enter the sale order date" class="form-control">
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" @click="updateDC">Update DC Info</button>
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
<div class="modal" tabindex="-1" role="dialog" id="updateInvoiceModal">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Update Invoice Details</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group">
			<span class="right badge badge-secondary">Invoice No: </span>
        	<input type="text" v-model="invoice_no" placholder="Enter the invoice number" class="form-control">
        </div>
		<div class="form-group">
			<span class="right badge badge-secondary">Invoice Date: </span>
        	<input type="date" v-model="invoice_date" placholder="Enter the invoice date" class="form-control">
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" @click="updateInvoice">Update Invoice Info</button>
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
<div class="modal" tabindex="-1" role="dialog" id="updateEwaybillModal">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Update Ewaybill Details</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group">
			<span class="right badge badge-secondary">Enter Ewaybill number </span>
        	<input type="text" v-model="ewaybill_no" placholder="Enter the Ewaybill number" class="form-control">
        </div>
		<div class="form-group">
			<span class="right badge badge-secondary">Enter Ewaybill Date </span>
        	<input type="date" v-model="ewaybill_date" placholder="Enter the Ewaybill date" class="form-control">
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" @click="updateEwaybill">Update Ewaybill Info</button>
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
<div class="modal" tabindex="-1" role="dialog" id="approveDCModal">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Approve DC</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <h5>Are you sure the data is verified and approved by you?</h5>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" @click="approveDeliveryCommitment">Yes</button>
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
<div class="modal" tabindex="-1" role="dialog" id="updateConfirmedDeliveryDateModal">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Update Confirmed Delivery Date</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group">
			<span class="right badge badge-secondary">Enter Confirmed Delivery Date: </span>
        	<input type="date" v-model="confirmed_delivery_date" placholder="Enter the confirmed delivery date" class="form-control">
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" @click="updateConfirmedDeliveryDate">Update Confirmed Delivery Date</button>
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
<div class="modal" tabindex="-1" role="dialog" id="updateBuybackStatusModal">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Update Buyback Status</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">

       <div class="form-group">
     <span class="right badge badge-secondary">Is Buyback collected? </span>
       <label>
           <input v-model="buyback_collected" name="buyback_collected" type="radio" autocomplete="off" v-bind:value="'1'" checked/>
           Collected
       </label>
       <label>
           <input v-model="buyback_collected" name="buyback_collected" type="radio" autocomplete="off" v-bind:value="'0'" checked/>
           Not Collected
       </label>
     </div>

       <div class="form-group">
     <span class="right badge badge-secondary">Buyback Details:</span>
       <input type="text" placeholder="Enter the Buyback Details" style="width:100% !important;" v-model="buyback_details" class="form-control" required/>
     </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" @click="updateBuyback">Update</button>
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
<div class="modal" tabindex="-1" role="dialog" id="updateCollectedAmountModal">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Update Collected Amount</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
		<p>Total Amount: {{total_amount}}</p>
		<p>Pending Amount: {{pending_amount}}</p>
        <div class="form-group">
			<span class="right badge badge-secondary">Collected Amount:</span>
        	<input type="number" v-model="collected_amount" placholder="Enter the collected amount" class="form-control">
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" @click="updateCollectedAmount">Update</button>
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
<div class="modal" tabindex="-1" role="dialog" id="updateStatusModal">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Update DC Status</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group">
			<span class="right badge badge-secondary">Pick Status:</span>
			<select v-model="delivery_status" style="width: 100% !important" class="form-control">
                            <option v-for="j in delivery_status_list" :key="j.id" :value="j.status">
                              {{ j.status}}
                             </option>
                             <!-- <span v-if="errors.delivery_route" :class="['badge bg-danger']">Please choose a route from route master</span> -->
                          </select>
        </div>
		<div class="form-group">
			<span class="right badge badge-secondary">Notes: </span>
			<input type="text" v-model="notes" placholder="Enter notes if any" class="form-control">
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" @click="updateDCStatus">Update</button>
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
    </section>
    <!-- /.content -->



<!-- All VUE Parts end before this comment -->
        <!-- </div>
        <div v-if="!$gate.isSysAdmin()">
             <access-denied></access-denied>
        </div> -->
    </div>
</template>

<script>
		 import Pagination from '../../pagination.vue';
         import {vModelSelect} from "@vue/runtime-dom";
		 export default {
        mounted() {
            console.log('Component mounted.')
        },

        components: {pagination:Pagination},

        created(){
			this.getDeliveryRoutes();
			this.getDeliveryItemCategories();
			this.getDeliveryStatusList();
            this.pollData();
            this.getBranches();
            const currentDate = new Date();
            const year = currentDate.getUTCFullYear();
            const month = (currentDate.getUTCMonth() + 1).toString().padStart(2, '0');
            const day = currentDate.getUTCDate().toString().padStart(2, '0');
            const hours = currentDate.getUTCHours().toString().padStart(2, '0');
            const minutes = currentDate.getUTCMinutes().toString().padStart(2, '0');
            const seconds = currentDate.getUTCSeconds().toString().padStart(2, '0');
            this.today_date = `${year}-${month}-${day}T00:00:00.000000Z`;
            console.log(this.today_date);
            var today = new Date();
            var dd = today.getDate();
            var mm = today.getMonth()+1;
            var yyyy = today.getFullYear();
            this.params.confirmed_delivery_date = yyyy+'-'+mm+'-'+dd;
            console.log(this.params.confirmed_delivery_date);
            this.usertype = window.user.user_type;
            if(this.usertype=='mis-admin' || this.usertype=='secondary-mis-admin' || this.usertype=='hr-admin' || this.usertype=='online-sales-manager'|| this.usertype=='online-sales-associate' || this.usertype=='cc-manager' || this.usertype=='cc-agent' || this.usertype=='service-admin' || this.usertype=='purchase-admin' || this.usertype=='purchase-manager' || this.usertype=='secondary-purchase-admin' || this.usertype=='secondary-purchase-manager') {
                this.params.branch = '';
            }
            else if(this.usertype=='warehouse-manager' || this.usertype=='store-manager') {
                this.params.branch = '';
                this.params.serving_branch=window.user.branch;
            }
            else{
                this.params.branch=window.user.branch;
                this.getLinkedBranches();
            }
            this.getAllDeliveryCommitments();
        },

        data(){
        	return {
        		delivery_routes: [],
                branches:[],
                today_date:'',
                linked_branches:[],
                usertype:"",
				delivery_commitments:[],
				delivery_item_categories: [],
        		pagination: {
          			lastPage: '',
           			currentPage: '',
            		total: '',
            		lastPageUrl: '',
            		nextPageUrl: '',
            		prevPageUrl: '',
            		from: '',
            		to: '',
         			},
         		route: '',
            	description: '',
				results: '',
				dc_status: '',
				delivery_status:'',
				delivery_status_list:'',
				confirmed_delivery_date: '',
				notes: '',
				dc_id: '',
				total_results: '',
				sale_order_no: '',
				sale_order_date: '',
				invoice_no: '',
				invoice_date:'',
				ewaybill_no:'',
				ewaybill_date:'',
				total_amount: '',
				pending_amount: '',
				receipt_image: '',
				gatepass_image: '',
				buyback_collected: '',
				buyback_details: '',
				collected_amount: '',
				dc_total: '',
				dc_pending: '',
				dc_collected: '',
                interval: null,
            	params: new Form({
					    from_date: null,
						to_date: null,
         				confirmed_delivery_date: null,
         				preferred_delivery_date: null,
         				delivery_status: null,
						delivery_route: null,
						delivery_item_category: null,
         				phone_number: null,
         				gatepass_no: null,
         				customer_name: null,
         				item_code: null,
         				dc_id: null,
						is_combo: null,
						is_urgent: null,
						is_billed: null,
						is_invoiced: null,
						summary: null,
                    serving_branch:null,
						gst_bill_required: null
         		}),
        	}
        },

        methods: {
            pollData(){
                this.interval = setInterval(() => {
                    this.getAllDeliveryCommitments();
                }, 100000)
            },
            getBranches(){
                if(this.usertype == 'zonal-manager'){
                    axios.post("/api/getZonalManagerBranches")
                        .then(response => {
                            this.branches = response.data;
                        });
                }
                else{
                    axios.post("/api/getSAPBranches")
                        .then(response => {
                            this.branches = response.data;
                        })
                }
            },
            getLinkedBranches(){
                axios.post("/api/getLinkedBranches",{ branch: this.params.branch })
                    .then(response => {
                        this.linked_branches = response.data.data;
                    });
            },
			receiptImageModalPrompt(dc){
				this.dc_id = dc.id;
				this.receipt_image = dc.receipt_image;
    			$("#receiptImageModal").modal("show");
    		},
			gatepassImageModalPrompt(dc){
    			this.dc_id = dc.id;
				this.gatepass_image = dc.gatepass_image;
    			$("#gatepassImageModal").modal("show");
    		},
			updateBuybackStatusModalPrompt(dc){
				this.dc_id = dc.id;
				this.buyback_collected = dc.buyback_collected;
				this.buyback_details = dc.buyback_details;
    			$("#updateBuybackStatusModal").modal("show");
    		},
			updateBuyback(){
    			axios.post("/api/markBuybackCollection", {id: this.dc_id, buyback_collected: this.buyback_collected, buyback_details:this.buyback_details})
    			.then(() => {
    				toast.fire({
    					icon: 'success',
    					title: 'Buyback Info Updated!'
    				});
    				$("#updateBuybackStatusModal").modal("hide");
    				this.getAllDeliveryCommitments();
    			});
    		},
			updateCollectedAmountModalPrompt(dc){
				this.dc_id = dc.id;
				this.total_amount = dc.total_amount;
				this.pending_amount = dc.pending_amount;
				this.collected_amount = dc.collected_amount;
    			$("#updateCollectedAmountModal").modal("show");
    		},
			updateCollectedAmount(){
    			axios.post("/api/updateDCCollectedAmount", {id: this.dc_id, collected_amount: this.collected_amount})
    			.then(() => {
    				toast.fire({
    					icon: 'success',
    					title: 'Collected Amount Updated!'
    				});
    				$("#updateCollectedAmountModal").modal("hide");
    				this.getAllDeliveryCommitments();
    			});
    		},
			approveDCModalPrompt(dc){
				this.dc_id = dc.id;
    			$("#approveDCModal").modal("show");
    		},
			approveDeliveryCommitment(){
				axios.post("/api/approveDC", {id: this.dc_id})
    			.then(() => {
    				toast.fire({
    					icon: 'success',
    					title: 'DC Details Approved!'
    				});
    				$("#approveDCModal").modal("hide");
    				this.getAllDeliveryCommitments();
    			});
			},
			updateDCModalPrompt(dc){
				this.dc_id = dc.id;
    			$("#updateDCModal").modal("show");
    		},
			updateDC(){
    			axios.post("/api/updateSalesDCInfo", {id: this.dc_id, sale_order_no: this.sale_order_no, sale_order_date: this.sale_order_date})
    			.then(() => {
    				toast.fire({
    					icon: 'success',
    					title: 'DC Details Updated!'
    				});
    				$("#updateDCModal").modal("hide");
    				this.getAllDeliveryCommitments();
    			});
    		},
			updateInvoiceModalPrompt(dc){
				this.dc_id = dc.id;
    			$("#updateInvoiceModal").modal("show");
    		},
			updateInvoice(){
    			axios.post("/api/updateInvoiceInfo", {id: this.dc_id, invoice_no: this.invoice_no, invoice_date:this.invoice_date})
    			.then(() => {
    				toast.fire({
    					icon: 'success',
    					title: 'Invoice Details Updated!'
    				});
    				$("#updateInvoiceModal").modal("hide");
    				this.getAllDeliveryCommitments();
    			});
    		},
			updateEwaybillModalPrompt(dc){
				this.dc_id = dc.id;
    			$("#updateEwaybillModal").modal("show");
    		},
			updateEwaybill(){
    			axios.post("/api/updateEwaybillInfo", {id: this.dc_id, ewaybill_no: this.ewaybill_no, ewaybill_date: this.ewaybill_date})
    			.then(() => {
    				toast.fire({
    					icon: 'success',
    					title: 'Ewaybill Details Updated!'
    				});
    				$("#updateEwaybillModal").modal("hide");
    				this.getAllDeliveryCommitments();
    			});
    		},
			updateConfirmedDeliveryDateModalPrompt(dc){
				this.dc_id = dc.id;
    			$("#updateConfirmedDeliveryDateModal").modal("show");
    		},
			updateConfirmedDeliveryDate(){
    			axios.post("/api/updateConfirmedDeliveryDate", {id: this.dc_id, confirmed_delivery_date: this.confirmed_delivery_date})
    			.then(() => {
    				toast.fire({
    					icon: 'success',
    					title: 'Confirmed Delivery Date Updated!'
    				});
    				$("#updateConfirmedDeliveryDateModal").modal("hide");
    				this.getAllDeliveryCommitments();
    			});
    		},
			updateStatusModalPrompt(dc){
				this.dc_id = dc.id;
    			// this.allotment_id = allotment.id;
    			// this.title = "A "+allotment.gift_rule.assigned_gift+" is given to "+allotment.gift_registration.first_name+" "+allotment.gift_registration.last_name+", "+allotment.phone;
    			$("#updateStatusModal").modal("show");
    		},
			updateDCStatus(){
    			axios.post("/api/updateDCStatus", {id: this.dc_id, delivery_status:this.delivery_status, notes: this.notes})
    			.then(() => {
    				toast.fire({
    					icon: 'success',
    					title: 'DC Status Updated!'
    				});
    				$("#updateStatusModal").modal("hide");
    				this.getAllDeliveryCommitments();
    			});
    		},

			viewDeliveryCommitment(dc){
        		window.open("/delivery-commitment/view/"+dc.id, "_blank");
        	},

			getDeliveryRoutes() {
            axios.post("/api/getDeliveryRoutes").then(response => {
                this.delivery_routes = response.data;
            });
       		},

			getDeliveryStatusList() {
            axios.post("/api/getDeliveryStatusList").then(response => {
                this.delivery_status_list = response.data;
            });
        	},

			getDeliveryItemCategories() {
            axios.post("/api/getDeliveryItemCategories").then(response => {
                this.delivery_item_categories = response.data;
            });
        	},

        	getAllDeliveryCommitments(url="/api/getAllDeliveryCommitments"){
        		axios.post(url, {results: this.results, params: this.params})
        		.then(response => {
        			this.delivery_commitments = response.data.data.data;
        			this.configPagination(response.data.data);
					this.total_results = response.data.data.total;
					this.dc_total = response.data.total_amount;
					this.dc_pending= response.data.pending_amount;
					this.dc_collected = response.data.collected_amount;
        		});
        	},
			reset(){
         			this.params.preferred_delivery_date= null;
         			this.params.delivery_status= null;
					this.params.delivery_route= null;
					this.params.delivery_item_category= null;
         			this.params.phone_number= null;
         			this.params.gatepass_no= null;
					this.params.summary = null;
         			this.params.customer_name= null;
         			this.params.item_code= null;
					this.invoiced = null,
					this.billed = null,
					this.summary = null,
         			this.params.dc_id= null;
					this.params.is_combo= null;
					this.params.is_urgent= null;
					this.params.from_date= null;
					this.params.to_date= null;
					this.params.gst_bill_required= null;
                var today = new Date();
                var dd = today.getDate();
                var mm = today.getMonth()+1;
                var yyyy = today.getFullYear();
                this.params.confirmed_delivery_date = yyyy+'-'+mm+'-'+dd;
                if(this.usertype=='mis-admin' || this.usertype=='secondary-mis-admin' || this.usertype=='hr-admin'|| this.usertype=='online-sales-manager'|| this.usertype=='online-sales-associate'  || this.usertype=='service-admin' || this.usertype=='cc-manager' || this.usertype=='cc-agent' || this.usertype=='purchase-admin' || this.usertype=='purchase-manager' || this.usertype=='secondary-purchase-admin' || this.usertype=='secondary-purchase-manager') {
                    this.params.branch = '';
                    this.params.serving_branch = '';
                }
                else if(this.usertype=='warehouse-manager' || this.usertype=='store-manager') {
                    this.params.branch = '';
                    this.params.serving_branch=window.user.branch;
                }
                else{
                    this.params.branch=window.user.branch;
                    this.getLinkedBranches();
                }
					this.getDeliveryRoutes();
					this.getDeliveryItemCategories();
					this.getDeliveryStatusList();
					this.getAllDeliveryCommitments();
			},

        	configPagination(data){
      			this.pagination.lastPage=data.lastPage;
         		this.pagination.currentPage=data.current_page;
    	  		this.pagination.total=data.total;
        		this.pagination.lastPageUrl=data.last_page_url;
       			this.pagination.nextPageUrl=data.next_page_url;
       			this.pagination.prevPageUrl=data.prev_page_url;
     		 		this.pagination.from=data.from;
        		this.pagination.to=data.to;
    			},

    			addMasterDeliveryRoute(){
    				axios.post("/api/addMasterDeliveryRoute", {branch_code: this.branch_code, route: this.route, description:this.description})
    				.then(() => {
    					this.getMasterDeliveryRoutes();
    					toast.fire({
    						title: 'Added',
    						icon: 'success'
    					});
    				})
    				.catch(() => {
    					toast.fire({
    						title: 'Failed! Input Valid Date',
    						icon: 'error'
    					});
    				});
    			},

				exportCommitments(){
        		axios({
        			url: "/api/getdeliveryCommitmentsExport",
        			data: {
		      			results: this.results, params: this.params
				     	},
				     	method: 'post',
						responseType: 'blob'
        		})
        		.then(response => {
        			toast.fire({
        				icon: 'success',
        				title: 'Report Generated'
        			})
        			var blob = new Blob ([response.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
        			saveAs(response.data, "delivery_commitments_report.xlsx");
        		});
        	},

    			changeStatus(id){
    				axios.post("/api/updateMasterDeliveryRoute", {id: id})
    				.then(() => {
    					this.getMasterDeliveryRoutes();
    				})
    				.catch(() => {
    					toast.fire({
    						title: 'Failed!',
    						icon: 'error'
    					});
    				});
    			},

    			deleteRoute(id){
    				axios.post("/api/deleteMasterDeliveryRoute", {id: id})
    				.then(() => {
    					this.getLinkages();
    				})
    				.catch(() => {
    					toast.fire({
    						title: 'Failed!',
    						icon: 'error'
    					});
    				});
    			},
        },
             beforeDestroy(){
                 clearInterval(this.interval);
             },
    }
</script>
